import { Container, Sprite, randomRange } from '../../odie';
import { IAnimation } from '../../lib/pattern/IAnimation';
import { getRelativeOffset } from '@play-co/timestep-core/ui';
import { getGoals } from 'src/game/scenes/Match2Scene';
import { WobbleAnimation } from './WobbleAnimation';
import gsap from 'gsap';
import { getGoalsPath } from '../util/assets';

export type PipeCollectedAnimationOptions = {
  wobbleView?: Container;
};

export class PipeCollectedAnimation extends Container implements IAnimation {
  private get icon() {
    return `${getGoalsPath()}icon.smoke.png`;
  }

  constructor(private options: PipeCollectedAnimationOptions) {
    super();
  }

  public static assets(): string[] {
    return [];
  }

  public async start(): Promise<void> {
    if (this.options.wobbleView) {
      new WobbleAnimation({
        target: this.options.wobbleView,
      }).start();
    }

    const egg = Sprite.from(this.icon);
    egg.anchorX = 0.5;
    egg.anchorY = 0.5;

    await this.layEgg(egg);
    await this.flyToGoals(egg);
  }

  public stop() {}

  private async layEgg(egg: Sprite) {
    const duration = randomRange(0.5, 0.7);

    egg.anchorX = egg.anchorY = 0.5;
    egg.scaleX = egg.scaleY = 0;
    egg.x = 0;
    egg.y = 0;
    this.addChild(egg);

    gsap.to(egg, {
      x: 20,
      duration: duration * 0.7,
      ease: 'sine.out',
    });

    await gsap.to(egg, {
      y: -20,
      scaleX: 0.9,
      scaleY: 0.9,
      duration: duration * 0.35,
      ease: 'quad.out',
    });

    await gsap.to(egg, {
      y: 20,
      scaleX: 1.3,
      scaleY: 0.7,
      duration: duration * 0.35,
      ease: 'quad.in',
    });

    await gsap.to(egg, {
      y: 20,
      scaleX: 1,
      scaleY: 1,
      duration: duration * 0.3,
      ease: 'back.out',
    });

    this.removeChild(egg);
  }

  private async flyToGoals(egg: Sprite) {
    const duration = randomRange(0.5, 0.7);
    const goals = getGoals();
    const target = goals?.getGoal('pipe');

    // Goals and target goal are required to this animation
    if (!goals || !target) return;

    const goalsOffset = getRelativeOffset(this.view, goals);
    const targetOffset = getRelativeOffset(target, goals);

    const fromX = egg.x + goalsOffset.x;
    const fromY = egg.y + goalsOffset.y;
    const toX = targetOffset.x + target.style.width * 0.5;
    const toY = targetOffset.y + target.style.height * 0.5;

    egg.x = fromX;
    egg.y = fromY;

    goals.addSubview(egg.view);

    const scaleUp = { scaleX: 1, scaleY: 1 };

    gsap.to(egg, {
      ...scaleUp,
      duration: duration * 0.3,
      ease: 'sine.out',
    });

    const scaleToGoal = { scaleX: 0.5, scaleY: 0.5 };

    gsap.to(egg, {
      ...scaleToGoal,
      duration: duration * 0.7,
      ease: 'sine.in',
      delay: duration * 0.3,
    });

    await gsap.to(egg, {
      x: toX,
      y: toY,
      duration,
      ease: 'sine.inOut',
    });
    egg.view.removeFromSuperview();
  }
}
